import {readCatalogCollectionResponse} from './publicCatalogResponse';

const own = (value, key) => {
    if (value === null || typeof value !== 'object') return undefined;
    const descriptor = Object.getOwnPropertyDescriptor(value, key);
    return descriptor && Object.prototype.hasOwnProperty.call(descriptor, 'value') ? descriptor.value : undefined;
};
const record = value => value !== null && typeof value === 'object' && !Array.isArray(value);

// The frozen render guard reads DTO fields directly. Reject accessors and
// inherited data before handing it a transport payload; never rewrite its DTO.
function passiveTree(value, ancestors = new Set()) {
    if (value === null || value === undefined) return true;
    if (typeof value !== 'object') return ['string', 'boolean', 'number'].includes(typeof value) &&
        (typeof value !== 'number' || Number.isFinite(value));
    const prototype = Object.getPrototypeOf(value);
    if (prototype !== null && prototype !== (Array.isArray(value) ? Array.prototype : Object.prototype)) return false;
    if (ancestors.has(value)) return false;
    ancestors.add(value);
    const descriptors = Object.getOwnPropertyDescriptors(value);
    if (Array.isArray(value)) {
        for (let index = 0; index < value.length; index += 1) {
            if (!Object.prototype.hasOwnProperty.call(descriptors, index)) return false;
        }
    }
    for (const key of Reflect.ownKeys(descriptors)) {
        const descriptor = descriptors[key];
        if (typeof key !== 'string' || !Object.prototype.hasOwnProperty.call(descriptor, 'value') ||
            !passiveTree(descriptor.value, ancestors)) return false;
    }
    ancestors.delete(value);
    return true;
}

/** Shape/render safety only. A successful packet is not purchase authority. */
export function readPublicSearchPacket(operation, response) {
    try {
        const status = own(response, 'status');
        const failure = {ok: false, status: [400, 404, 503].includes(status) ? status : 503};
        if (!Number.isInteger(status) || status < 200 || status >= 300) return failure;
        const packet = own(response, 'data');
        const keys = ['schemaVersion', 'operation', 'publicationMode', 'commerceMode', 'handled', 'payload'];
        if (!record(packet) || Reflect.ownKeys(packet).length !== keys.length ||
            !keys.every(key => Object.prototype.hasOwnProperty.call(packet, key)) || !passiveTree(packet) ||
            packet.schemaVersion !== 'public-search-v1' || packet.operation !== operation ||
            !['legacy', 'shadow', 'admin'].includes(packet.publicationMode) ||
            !['legacy', 'shadow', 'enforced'].includes(packet.commerceMode) ||
            packet.handled !== (packet.publicationMode === 'admin' || packet.commerceMode === 'enforced')) return failure;
        const payload = packet.payload;
        const valid = operation === 'rows' ? record(payload) && Array.isArray(payload.rows) && payload.rows.length <= 100 &&
            payload.count >= payload.rows.length && readCatalogCollectionResponse('rows', {status, data: payload}).ok
            : operation === 'ids' ? record(payload) && Array.isArray(payload.data) && payload.data.length <= 200 &&
                readCatalogCollectionResponse('rows', {status, data: {rows: payload.data, count: payload.data.length}}).ok
                : operation === 'tips' ? Array.isArray(payload) && payload.length <= 5 && payload.every(tip =>
                    record(tip) && Object.keys(tip).length === 1 && typeof tip.name === 'string') : false;
        return valid ? {ok: true, packet} : failure;
    } catch {
        return {ok: false, status: 503};
    }
}
